import React from "react"
import QueueAnim from "rc-queue-anim"
import TweenOne from "rc-tween-one"
import { get } from "lodash"
import { Image, Flex, Box } from "rebass"
import { TextAnimation, defaultSubtitle, defaultTitle } from "./Text"

const RightImageElement = (props) => {
  const { data, id, matches, widthContainer } = props
  const boxImage = get(data, "position.boxImage", "486px")
  const marginLeftText = get(data, "position.marginLeftText", "-100px")
  const isAnimation = get(data, "image.isAnimation", false)
  const animationImage = isAnimation
    ? {
        type: get(data, "image.animation.type", "from"),
        ease: get(data, "image.animation.ease", "easeInQuart"),
        opacity: get(data, "image.animation.opacity", 0),
        delay: get(data, "image.animation.delay", 40),
        duration: get(data, "image.animation.duration", 1500),
      }
    : {}

  const mobileImage = get(
    data,
    "url_image_mobile",
    get(
      data,
      "url_image",
      "https://via.placeholder.com/400x400?text=400x400=CMS"
    )
  )

  const useMobile = matches
    ? mobileImage !== ""
      ? mobileImage
      : get(
          data,
          "url_image",
          "https://via.placeholder.com/400x400?text=400x400=CMS"
        )
    : get(
        data,
        "url_image",
        "https://via.placeholder.com/480x480?text=480x480=CMS"
      )

  const title = get(data, "title", defaultTitle)
  const subtitle = get(data, "subtitle", defaultSubtitle)
  const imageSize = widthContainer > 480 ? boxImage : widthContainer
  const direction = widthContainer > 480 ? "row" : "column-reverse"
  const ml = widthContainer > 480 ? marginLeftText : "0px"

  return (
    <Box w={[1]}>
      <QueueAnim name={`Queue-${data.name}-${id}`}>
        <Flex w={[1]} align={"center"}>
          <Flex w={[1]} direction={[direction]} align={"center"}>
            <Flex
              w={[1]}
              direction={"column"}
              ml={["0px", "0px", ml]}
              style={{ zIndex: 9 }}
            >
              <TextAnimation data={title} widthContainer={widthContainer} />
              <TextAnimation data={subtitle} widthContainer={widthContainer} />
            </Flex>
            <TweenOne
              animation={animationImage}
              name={`TweenOne-image-right-${data.name}-${id}`}
            >
              <Image src={useMobile} style={{ width: imageSize }} />
            </TweenOne>
          </Flex>
        </Flex>
      </QueueAnim>
    </Box>
  )
}

export default RightImageElement



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/carouselAnimation/RightImageElement.js